import axios from "axios";
import { configCurrentSite } from "../utils/config";
import { devLog } from "../utils/devLog";
import { attachTokenRefreshInterceptor } from "./tokenRefreshInterceptor";

// Create axios instance without baseURL - will be set dynamically per request
const api = axios.create({
  timeout: 30000, // 30 second timeout
  withCredentials: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use((config) => {
  const axiosConfig = config;

  // Dynamically determine baseURL based on current execution context
  const isServer = typeof window === 'undefined';
  const baseURL = isServer
    ? (process.env.SERVER_URL || 'http://cms-backend-service.internal.local:5001')
    : window.location.origin;

  axiosConfig.baseURL = baseURL;

  const logUrl = axiosConfig.url?.startsWith('http')
    ? axiosConfig.url
    : `${baseURL}${axiosConfig.url || ''}`;

  devLog(`[API] ${isServer ? 'SERVER' : 'CLIENT'} - Request URL: ${logUrl}`);

  // axios 1.x: per-request `config.headers` is an AxiosHeaders instance with no
  // `.common` bucket (that only exists on axios.defaults.headers). Setting
  // `headers.common.siteId` here threw a TypeError inside the interceptor, so
  // every client request was aborted before it left the browser (SCRUM-710,
  // regression from the axios 0.x→1.x upgrade in SCRUM-422). Set directly.
  // SCRUM-1850: only when the caller passed none — the score preview asks for a
  // site other than the current one, and AxiosHeaders is case-insensitive, so
  // an unconditional set overwrote its `siteid` (the lib/api.js rule, SCRUM-744).
  if (!axiosConfig.headers.has("siteId")) {
    axiosConfig.headers.siteId = configCurrentSite.CURRENT_SITE_ID;
  }
  axiosConfig.headers.siteDomain = configCurrentSite.CURRENT_DOMAIN_SITE;
  return axiosConfig;
});

const clearLocalAuth = () => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem('role');
  localStorage.removeItem('permission');
  // SCRUM-1471 removed the only writer of `currentsite` (SiteSelector), so there is
  // nothing left for logout to clear.
};

attachTokenRefreshInterceptor(api, clearLocalAuth);

export default api;
